var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwoBags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2_Caf\\xE9s_op\\xE7\\xE3o_1_",
    "data-name": "2 Caf\\xE9s (op\\xE7\\xE3o 1)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.91 107.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#343233;stroke-width:2.94px;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#d83f28;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.26,103.71c-8.1,2.85-17.89,4.82-31.16,4.88a27.28,27.28,0,0,1-5.85-.53c-2.84-.59-4.61-1.47-5.77-2.81l0,0c-2.23-2.59-2.2-6.92-3.37-14.3L5.43,30.56a.2.2,0,0,0,0-.07v-.22a1,1,0,0,1,.84-.78l60-8.43.33,3.26",
    transform: "translate(-2.55 -9.25)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.26,103.71",
    transform: "translate(-2.55 -9.25)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.46,105.22,7.07,98.16C4,94.91,3.92,91.7,4,89L5.42,30.49a.2.2,0,0,1,0,.07l6.66,60.36C13.26,98.3,13.23,102.63,15.46,105.22Z",
    transform: "translate(-2.55 -9.25)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.43,30.27V25.8l.28-.18a1.13,1.13,0,0,0,.53-1,.81.81,0,0,0-.56-.81l-.25-.08v-1.7a3.68,3.68,0,0,1,3-3.58l55.11-7.74a2.59,2.59,0,0,1,2.92,2.75v1.7l-.24.16a1.16,1.16,0,0,0-.57,1,.85.85,0,0,0,.55.83l.26.1v3.84",
    transform: "translate(-2.55 -9.25)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    className: "cls-3",
    d: "M36.87,69.43a5.78,5.78,0,0,0-1.24,3.63,5.2,5.2,0,0,0,.55,2.4A5.62,5.62,0,0,0,37.7,77.3a7.36,7.36,0,0,0,2.22,1.18,8.29,8.29,0,0,0,2.72.43,9.65,9.65,0,0,0,3.66-.7,10.94,10.94,0,0,0,3.2-2l-9.33-9.84a15,15,0,0,0-3.3,3.08m2.19-17.59A3.81,3.81,0,0,0,37.8,54.7a3.28,3.28,0,0,0,.15,1,4.54,4.54,0,0,0,.53,1.06,11.46,11.46,0,0,0,1.06,1.36c.45.52,1,1.14,1.69,1.84a26.38,26.38,0,0,0,3.68-2.8,3.89,3.89,0,0,0,1.36-2.9,3.26,3.26,0,0,0-1.13-2.6,4.3,4.3,0,0,0-2.9-1,4.45,4.45,0,0,0-3.18,1.18",
    transform: "translate(-2.55 -9.25)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124,90.19l-.22,8.6a9.3,9.3,0,0,1-4.77,7.95c-.73.41-1.45.76-2.08,1.11-9.54,4.23-21.08,7.48-38.66,7.44a22.74,22.74,0,0,1-3.58-.29c-3.59-.61-5.7-1.53-7-3l0,0c-1.85-2.14-2.15-5.49-2.86-10.78-.14-1.09-.3-2.25-.5-3.52L57.58,37.26a.2.2,0,0,0,0-.07V37a1,1,0,0,1,.85-.78l9.25-1.3,50.86-7.15,4.93,49.79A99.11,99.11,0,0,1,124,90.19Z",
    transform: "translate(-2.55 -9.25)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.61,111.92l-8.39-7.06a10.83,10.83,0,0,1-1-1.15,11.56,11.56,0,0,1-2.06-8l1.37-58.52a.2.2,0,0,1,0,.07l6.67,60.36c.2,1.27.36,2.43.5,3.52C65.46,106.43,65.76,109.78,67.61,111.92Z",
    transform: "translate(-2.55 -9.25)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.75,23a.85.85,0,0,0,.54.83l.26.1v3.8L67.68,34.89l-9.25,1.3a1,1,0,0,0-.85.78V32.5l.28-.18a1.14,1.14,0,0,0,.53-1,.81.81,0,0,0-.56-.81l-.25-.08v-1.7a3.68,3.68,0,0,1,3-3.58l6.08-.86,49-6.88a2.6,2.6,0,0,1,2.93,2.75l0,1.7-.24.15A1.18,1.18,0,0,0,117.75,23Z",
    transform: "translate(-2.55 -9.25)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    className: "cls-3",
    d: "M89,76.13a5.86,5.86,0,0,0-1.24,3.63,5.18,5.18,0,0,0,.56,2.4A5.59,5.59,0,0,0,89.85,84a7.61,7.61,0,0,0,2.22,1.19,8.58,8.58,0,0,0,2.73.42,9.65,9.65,0,0,0,3.66-.7,11.07,11.07,0,0,0,3.2-2l-9.33-9.84A15,15,0,0,0,89,76.13m2.2-17.58A3.75,3.75,0,0,0,90,61.4a3,3,0,0,0,.16,1,4.46,4.46,0,0,0,.52,1.06,14.05,14.05,0,0,0,1.06,1.36c.46.52,1,1.14,1.69,1.84a26.55,26.55,0,0,0,3.69-2.8,3.88,3.88,0,0,0,1.36-2.9,3.31,3.31,0,0,0-1.13-2.6,4.32,4.32,0,0,0-2.91-1,4.45,4.45,0,0,0-3.17,1.19",
    transform: "translate(-2.55 -9.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoBags);
export default __webpack_public_path__ + "static/media/two-bags.8be13be04e911874a9ff3c4ff0479236.svg";
export { ForwardRef as ReactComponent };